const SESSION_HEADER = "X-Esign-Session"

export const withSession = (session: string | null) =>
  session ? { headers: { [SESSION_HEADER]: session } } : {}
